import { Component, Input, OnInit } from '@angular/core';
import { CGIBaselineAnswer } from 'modules/promptuary/interfaces/cgi.interface';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

@Component({
	selector: 'appointment-details-historic-tab',
	templateUrl: './appointment-details-historic-tab.component.html',
})
export class AppointmentDetailsHistoricTabComponent implements OnInit {
	@Input()
	contactId = null;
	cgiBaselineAnswer = null;

	constructor(public promptuaryService: PromptuaryService) {}

	public ngOnInit(): void {
		if (this.contactId) {
			this.getCGIBaselineAnswer();
		}
	}

	public getCGIBaselineAnswer(): void {
		this.promptuaryService
			.getCGIBaselineAnswer(this.contactId)
			.subscribe((cgiBaselineAnswer: CGIBaselineAnswer) => {
				this.cgiBaselineAnswer = cgiBaselineAnswer;
			});
	}
}
